const CHECK_IN_REQUIRED_EVENT = 'attendance:check-in-required'
export const START_ATTENDANCE_CHECK_IN_EVENT = 'attendance:start-check-in'
export const OPEN_HOME_DRAWER_EVENT = 'home:open-drawer'
export const START_ATTENDANCE_CHECK_IN_NAVIGATION_STATE = 'startAttendanceCheckIn'

export type CheckInRequiredDetail = {
  message?: string
}

export const showCheckInRequiredPrompt = (detail: CheckInRequiredDetail = {}) => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(CHECK_IN_REQUIRED_EVENT, { detail }))
}

export const startAttendanceCheckInJourney = () => {
  if (typeof window === 'undefined') return
  window.dispatchEvent(new CustomEvent(START_ATTENDANCE_CHECK_IN_EVENT))
}

export default CHECK_IN_REQUIRED_EVENT
